import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "shared/components/UIElements/TabPanel";

const MyTabs = ({ tabs, tabValue, onTabChange, isVertical }) => {
  const a11yProps = (index) => ({
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  });

  return (
    <div
      style={{
        display: "flex",
        height: isVertical ? "calc(100vh - 4rem)" : "100%",
        flexDirection: isVertical ? "row" : "column",
      }}
    >
      <Tabs
        orientation={isVertical ? "vertical" : "horizontal"}
        variant="scrollable"
        value={tabValue}
        onChange={onTabChange}
        sx={{
          display: "flex",
          borderRight: 1,
          borderColor: "divider",
          paddingTop: isVertical ? "20px" : "0px",
          paddingBottom: isVertical ? "20px" : "0px",
          marginTop: isVertical ? "0px" : "20px",
          marginBottom: isVertical ? "0px" : "0px",

          width: isVertical ? "250px" : "100%",
          backgroundColor: isVertical ? "var(--color-gray-surface)" : "transparent", // light background for vertical tabs
        }}
        TabIndicatorProps={{
          sx: {
            backgroundColor: "var(--color-link)",
            height: isVertical ? "100%" : "3px",
            width: isVertical ? "4px" : undefined, // dikeyse sol çizgi, yataysa alt çizgi
            left: isVertical ? 0 : 0,
            bottom: !isVertical ? 0 : 0,
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            sx={{
              textTransform: "none",
              justifyContent: isVertical ? "center" : "flex-start", // align text to the left
              alignItems: isVertical ? "flex-start" : "center", // align vertically left too
              textAlign: "left", // ensure text is left-aligned
              width: "100%", // use full width to allow alignment
              pl: isVertical ? 4 : 0,
              //paddingTop: isVertical && index === 0 ? "30px" : undefined, // add padding to the first tab if vertical
              //fontWeight: "bold",
              fontWeight: "normal",
              marginRight: isVertical ? "0px" : "10px", // right margin for horizontal tabs

              border: isVertical ? "none" : "1px solid var(--color-gray-selected)", // border for horizontal tabs
              fontSize: "16px",
              color: "var(--color-solid)",
              "&:hover": {
                backgroundColor: "var(--color-gray-hover)", // hover effect
              },
              "&.Mui-selected": {
                // fontWeight: 600,
                color: "var(--color-primary-surface)", // selected tab color
                backgroundColor: "var(--color-gray-selected)", // selected tab background color
              },
              transition: "all 0.2s ease-in-out", // 👈 burada
            }}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
      {tabs.map((tab, index) => (
        <TabPanel
          key={index}
          value={tabValue}
          index={index}
          style={{ padding: isVertical ? "0px" : "0px", borderRadius: isVertical ? "0px" : "0px", width: "100%" }}
        >
          {/* <div style={{ padding: "10px" }}>{tab.content}</div> */}
          {tab.content}
        </TabPanel>
      ))}
    </div>
  );
};

MyTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  tabValue: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default MyTabs;
